import UAParser from 'ua-parser-js';

const parser = new UAParser();

const addClass = (str) => {
    const arr = str.split(' ');
    arr.forEach(cls => {
        document.body.classList.add(cls);
    });
};

const deviceType = parser.getDevice().type;
// console.log('deviceType: ', deviceType);
if (deviceType) {
    addClass(deviceType);
}

const osName = parser.getOS().name;
// console.log('osName: ', osName);
if (osName) {
    addClass(osName);
}

const browserName = parser.getBrowser().name;
// console.log('browserName: ', browserName);
if (browserName) {
    addClass(browserName);
}
